import { SAVE_DRAFT_TIMEOUT } from '../../../../constants/draft'
import { updateStateValue } from '../../../../utils/react'
import { resetEmailCreationFormDataRecipients } from '../../EmailCreationForm'
import { useEmailDraftProvider } from '../useEmailDraftProvider'

export function useEmailDraftTableProvider(prefix) {
  const draft = useEmailDraftProvider(prefix)

  // Override setDraft to reset recipients
  return {
    ...draft,
    setDraft: (nextDraftAction, timeout = SAVE_DRAFT_TIMEOUT) => {
      const { setDraft } = draft

      setDraft(
        currDraft =>
          resetEmailCreationFormDataRecipients(
            updateStateValue(nextDraftAction, currDraft)
          ),
        timeout
      )
    },
  }
}
